module.exports = __webpack_public_path__ + "img/ihm_bpb.9301773e.png";